export default __webpack_public_path__ + "static/media/heroDotted.84a5ff84.svg";